import { useEffect } from 'react';
import useAuth from '../hooks/useAuth';

const TawkToWidget = () => {
  const { usuario, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!usuario || ['admin', 'exxer'].includes(usuario.tipo_usuario)) return;

    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (isLocalhost) return;

    if (window.Tawk_API || document.getElementById('tawk-script')) return;

    const timeout = setTimeout(() => {
      const script = document.createElement('script');
      script.src = 'https://embed.tawk.to/68064ac0dafe3e190b11250c/1ipc9808c';
      script.async = true;
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      script.id = 'tawk-script';

      document.body.appendChild(script);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [usuario, loading]);

  return null;
};

export default TawkToWidget;
